<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备ID')">
                <a-input :placeholder="$t('请输入设备ID')" v-model="queryParam.deviceId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('安装位置')">
                <j-input :placeholder="$t('输入安装位置模糊搜索')" v-model="queryParam.deviceLocation"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('联网状态')">
                <j-dict-select-tag v-model="queryParam.deviceNetworkedStatus" :placeholder="$t('请输入联网状态')" dictCode="wq_device_networked_status" ></j-dict-select-tag>
              </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('校验标准')">
                <a-select v-model="queryParam.standardId" :placeholder="$t('请选择校验标准')">
                  <a-select-option v-for="data in CalibrationStandard" :key="data.id" :value="data.id">
                    {{data.batchNo}}
                  </a-select-option>
                </a-select>
                <!-- <a-input placeholder="请输入标准" v-model="queryParam.standardId"></a-input> -->
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('wq_device')">{{ $t('导出') }}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{ $t('导入') }}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="deviceNetworkedStatus" slot-scope="text, record">
          <DeviceNetwork :status="record.deviceNetworkedStatus"></DeviceNetwork>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('修改') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
            <a>{{ $t('删除') }}</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <wQ-device-modal ref="modalForm" @ok="modalFormOk"></wQ-device-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,putAction } from '@/api/manage'
  import { listSize } from '@/utils/util'
  import {isUndefined} from'@/utils/validate'
  import WQDeviceModal from './modules/WQDeviceModal'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'WQDeviceList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      // JDate,
      WQDeviceModal,
      JInput
    },
    data () {
      return {
        description: 'wq_device管理页面',
        url: {
          list: "/wq/wQDevice/list",
          delete: "/wq/wQDevice/delete",
          deleteBatch: "/wq/wQDevice/deleteBatch",
          exportXlsUrl: "/wq/wQDevice/exportXls",
          importExcelUrl: "wq/wQDevice/importExcel",
          CalibrationStandard: "/wq/wQCheckBaseStandard/list",
        },
        CalibrationStandard:[], //校验标准
        dictOptions:{},
      }
    },
    created() {
      this.queryCalibrationStandard();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('设备ID'),
            align:"center",
            dataIndex: 'deviceId'
          },{
            title: this.$t('安装位置'),
            align:"center",
            dataIndex: 'deviceLocation'
          },{
            title: this.$t('联网状态'),
            align:"center",
            dataIndex: 'deviceNetworkedStatus',
            scopedSlots: { customRender: 'deviceNetworkedStatus' }
          },{
            title: this.$t('校验标准'),
            align:"center",
            dataIndex: 'standardId_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('修改人'),
            align:"center",
            dataIndex: 'updateBy'
          },{
            title: this.$t('修改时间'),
            align:"center",
            dataIndex: 'updateTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      queryCalibrationStandard() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.CalibrationStandard, params).then((res) => {
          if(res.success){
            this.CalibrationStandard = res.result.records;
            console.log(this.CalibrationStandard);
          }
        })
      },
      handleDetail:function(record){
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title=this.$t("详情");
      this.$refs.modalForm.disableSubmit = true;
    },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
